/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-25 16:32:59
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\invertory\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询即时库存列表
export function getInventoryList(params) {
  return request({
    url: '/wms/stock/listProduct',
    method: 'get',
    params
  })
}

// 查询即时库存详情列表
export function getInvertoryRecordsDetail(params) {
  return request({
    url: '/wms/stockDetail/list',
    method: 'get',
    params
  })
}
